// extracted by mini-css-extract-plugin
module.exports = {"switchingHoverImage":"styles_switchingHoverImage__2hMPg"};